import { del, get, post, put } from "../../data/api";

export async function getAdminAlloVoisinsMessages(skip = 0, take = 100) {
    return await get(`userprofile/allovoisins/messages?skip=${skip}&take=${take}`);
}

export async function getAdminAlloVoisinsConversation(chatId) {
    return await get(`userprofile/allovoisins/messages/${chatId}`);
}

export async function getAdminAlloVoisinsConversationByChannelId(channelId) {
    return await get(`userprofile/allovoisins/messages/channel/${encodeURIComponent(channelId)}`);
}

export async function sendAdminAlloVoisinsMessage(chatId, message) {
    return await post({ message }, `userprofile/allovoisins/messages/${chatId}`);
}

export async function getAdminAlloVoisinsSavedMessages() {
    return await get("userprofile/allovoisins/saved-messages");
}

export async function createAdminAlloVoisinsSavedMessage(savedMessage) {
    return await post(savedMessage, "userprofile/allovoisins/saved-messages");
}

export async function updateAdminAlloVoisinsSavedMessage(messageId, savedMessage) {
    return await put(savedMessage, `userprofile/allovoisins/saved-messages/${messageId}`);
}

export async function deleteAdminAlloVoisinsSavedMessage(messageId) {
    return await del(`userprofile/allovoisins/saved-messages/${messageId}`);
}
